import { render } from "./salary-all.vue?vue&type=template&id=3efc3b72&scoped=true&ts=true"
import script from "./salary-all.vue?vue&type=script&lang=ts"
export * from "./salary-all.vue?vue&type=script&lang=ts"

import "./salary-all.vue?vue&type=style&index=0&id=3efc3b72&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efc3b72"]])

export default __exports__